import { render, staticRenderFns } from "./platform_invoice_statuses.vue?vue&type=template&id=0f0aea14&scoped=true&"
import script from "./platform_invoice_statuses.vue?vue&type=script&lang=js&"
export * from "./platform_invoice_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0aea14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0aea14')) {
      api.createRecord('0f0aea14', component.options)
    } else {
      api.reload('0f0aea14', component.options)
    }
    module.hot.accept("./platform_invoice_statuses.vue?vue&type=template&id=0f0aea14&scoped=true&", function () {
      api.rerender('0f0aea14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/platform_invoice_statuses.vue"
export default component.exports